import { useState } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Logo } from "@/components/site/Logo";
import { LanguageSelect } from "@/components/site/LanguageSelect";
import { NAV, scrollToId } from "@/lib/content";

const QuoteButton = ({ onClick, testId }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className="rounded-full bg-slate-900 px-5 py-2.5 text-sm font-medium text-white transition-colors duration-200 hover:bg-emerald-500 hover:text-slate-900"
  >
    Preventivo Gratuito
  </button>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), 50);
  };
  return (
    <header data-testid="nav-header" className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
        <button data-testid="header-logo" onClick={() => go("home")} aria-label="Apollo Solar home">
          <Logo />
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-link-${n.id}`}
              onClick={() => go(n.id)}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900"
            >
              {n.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
        <LanguageSelect />
        <div className="hidden md:block">
          <QuoteButton testId="header-cta-quote-button" onClick={() => go("calcolatore-ai")} />
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button data-testid="mobile-menu-button" className="rounded-lg p-2 text-slate-700 md:hidden" aria-label="Apri menu">
              <Menu className="h-6 w-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-72">
            <SheetTitle className="mb-8"><Logo /></SheetTitle>
            <div className="flex flex-col gap-5">
              {NAV.map((n) => (
                <button key={n.id} data-testid={`mobile-nav-link-${n.id}`} onClick={() => go(n.id)} className="text-start text-lg font-medium text-slate-800">
                  {n.label}
                </button>
              ))}
              <QuoteButton testId="mobile-cta-quote-button" onClick={() => go("calcolatore-ai")} />
            </div>
          </SheetContent>
        </Sheet>
        </div>
      </div>
    </header>
  );
};
